// src/components/profile/ProfileLayout.tsx
import React, { useEffect } from 'react';
import { Outlet, NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useCart } from '../../context/CartContext';

const ProfileLayout: React.FC = () => {
  const { user } = useAuth();
    const { orders, fetchOrders, loading, error } = useCart();
    useEffect(() => {
        // console.log(user);
        if (user) {
            fetchOrders();
        }
    }, []);
  return (
    <div className="container mx-auto px-6 py-8 min-h-screen bg-neutral-50">
      <div className="flex flex-col md:flex-row gap-6">
        {/* Sidebar */}
        <aside className="w-full md:w-64 bg-white rounded-lg shadow-soft p-6">
          <div className="mb-6">
            <h2 className="text-xl font-heading font-semibold text-neutral-900">
              {user?.username}'s Profile
            </h2>
            <p className="text-sm text-neutral-600">Manage your account details</p>
          </div>
          <nav className="space-y-2">
            <NavLink
              to="/profile"
              end
              className={({ isActive }) =>
                `block px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                  isActive
                    ? 'bg-primary text-white'
                    : 'text-neutral-600 hover:bg-neutral-100'
                }`
              }
            >
              Order History
            </NavLink>
            <NavLink
              to="/profile/update"
              className={({ isActive }) =>
                `block px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                  isActive
                    ? 'bg-primary text-white'
                    : 'text-neutral-600 hover:bg-neutral-100'
                }`
              }
            >
              Update Profile
            </NavLink>
            <NavLink
              to="/profile/change-password"
              className={({ isActive }) =>
                `block px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                  isActive
                    ? 'bg-primary text-white'
                    : 'text-neutral-600 hover:bg-neutral-100'
                }`
              }
            >
              Change Password
            </NavLink>
            <NavLink
  to="/profile/wallet"
  className={({ isActive }) =>
    `block px-4 py-2 rounded-md text-sm font-medium transition-colors ${
      isActive
        ? 'bg-primary text-white'
        : 'text-neutral-600 hover:bg-neutral-100'
    }`
  }
>
  Wallet & Cashback
</NavLink>

          </nav>
        </aside>

        {/* Main Content */}
        <main className="flex-1 bg-white rounded-lg shadow-soft p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default ProfileLayout;